import type { FC } from 'react';

import React from 'react';
import { useNavigate } from 'react-router';
import { Wallet } from '@phosphor-icons/react';

import { EmptyState } from './EmptyState';

/**
 * What the deal lists say to someone signed in to an account that has not linked a wallet yet
 * (app#241; the words are Tim's, decision №15 of 2026-09-20).
 *
 * The api answers these lists with 403 `WALLET_NOT_LINKED`: deals and rentals belong to a wallet,
 * and the account has none. That used to reach the screen as "We could not load this — an error
 * on our side", which was untrue and left no way forward. It is neither an error nor a sign-in
 * form — the person is signed in — so the tone is neutral and the one action goes where the
 * wallet is linked: Profile, whose `Linked wallets` card offers a slot per wallet family.
 */
export const WalletNotLinkedState: FC = () => {
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<Wallet size={48} />}
      title="Your deals will appear here once a wallet is linked — deals and rentals belong to a wallet"
      action={{ label: 'Link a wallet', onClick: () => navigate('/profile') }}
    />
  );
};
